var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatching5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1056 0.447213C14.6686 0.165686 15.3314 0.165686 15.8944 0.447214L28.8944 6.94721C29.572 7.286 30 7.97852 30 8.73607V16.6667V24.5973C30 25.3548 29.572 26.0473 28.8944 26.3861L15.8944 32.8861C15.3314 33.1676 14.6686 33.1676 14.1056 32.8861L1.10557 26.3861C0.428004 26.0473 0 25.3548 0 24.5973V16.6667L0 8.73607C0 7.97852 0.428005 7.286 1.10557 6.94721L14.1056 0.447213Z",
    fill: "#5B6FB6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2170_7862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9.16666,
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2170_7862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 22.2917V21.0417H14.375V14.0573C14.1042 13.9635 13.8698 13.8177 13.6719 13.6198C13.474 13.4219 13.3281 13.1875 13.2344 12.9167H11.25L13.125 17.2917C13.125 17.8125 12.9115 18.2552 12.4844 18.6198C12.0573 18.9844 11.5417 19.1667 10.9375 19.1667C10.3333 19.1667 9.81771 18.9844 9.39062 18.6198C8.96354 18.2552 8.75 17.8125 8.75 17.2917L10.625 12.9167H9.375V11.6667H13.2344C13.3594 11.3021 13.5833 11.0026 13.9062 10.7682C14.2292 10.5338 14.5938 10.4167 15 10.4167C15.4062 10.4167 15.7708 10.5338 16.0938 10.7682C16.4167 11.0026 16.6406 11.3021 16.7656 11.6667H20.625V12.9167H19.375L21.25 17.2917C21.25 17.8125 21.0365 18.2552 20.6094 18.6198C20.1823 18.9844 19.6667 19.1667 19.0625 19.1667C18.4583 19.1667 17.9427 18.9844 17.5156 18.6198C17.0885 18.2552 16.875 17.8125 16.875 17.2917L18.75 12.9167H16.7656C16.6719 13.1875 16.526 13.4219 16.3281 13.6198C16.1302 13.8177 15.8958 13.9635 15.625 14.0573V21.0417H21.25V22.2917H8.75ZM17.8906 17.2917H20.2344L19.0625 14.5729L17.8906 17.2917ZM9.76562 17.2917H12.1094L10.9375 14.5729L9.76562 17.2917ZM15 12.9167C15.1771 12.9167 15.3255 12.8568 15.4453 12.737C15.5651 12.6172 15.625 12.4687 15.625 12.2917C15.625 12.1146 15.5651 11.9661 15.4453 11.8463C15.3255 11.7266 15.1771 11.6667 15 11.6667C14.8229 11.6667 14.6745 11.7266 14.5547 11.8463C14.4349 11.9661 14.375 12.1146 14.375 12.2917C14.375 12.4687 14.4349 12.6172 14.5547 12.737C14.6745 12.8568 14.8229 12.9167 15 12.9167Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatching5);
export default __webpack_public_path__ + "static/media/matching5.8f98c644.svg";
export { ForwardRef as ReactComponent };